/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @ngdoc service
 * @name HSGraphEdge
 * @author Alex Malitsky
 * @description
 *
 *     Item class for HealthScore graph edge.
 */
angular.module('aviApp').factory('HSGraphEdge', ['Item',
function(Item) {
    class HSGraphEdge extends Item {
        /** @override */
        getIdFromData_(...data) {
            return this.constructor.getIdFromData(...data);
        }

        /**
         * Static getIdFromData.
         * @static
         */
        static getIdFromData({ config }) {
            const { source, target } = config;

            return `${source}|${target}`;
        }

        /** @override */
        getName() {
            return this.id;
        }
    }

    HSGraphEdge.prototype.objectName = 'HSGraphNode';

    return HSGraphEdge;
}]);
